import { useCallback, useLayoutEffect, useState } from 'react';

import { getFromLocalStorage, saveToLocalStorage } from '@shared/helpers';

export const useNewFeatureChip = () => {
    const [enableNewFeatureChip, setEnableNewFeatureChip] = useState(false);

    useLayoutEffect(() => {
        const isNewFeatureChip = getFromLocalStorage('isChecklistNewChip');

        if (isNewFeatureChip === null) {
            saveToLocalStorage('isChecklistNewChip', true);
            setEnableNewFeatureChip(true);
            return;
        }

        setEnableNewFeatureChip(Boolean(isNewFeatureChip));
    }, []);

    const handleCloseNewFeatureChip = useCallback(() => {
        saveToLocalStorage('isChecklistNewChip', false);
        setEnableNewFeatureChip(false);
    }, []);

    return {
        enableNewFeatureChip,
        handleCloseNewFeatureChip,
    };
};
